module.exports = __webpack_public_path__ + "static/media/faq3.1f75ca90.png";